// export default {
//   primary: '#f44336',
//   secondary: '#673ab7',
//   accent: '#3f51b5',
//   error: '#cddc39',
//   warning: '#00bcd4',
//   info: '#4caf50',
//   success: '#8bc34a',
// };
export default {
  blueberry: {
    primary: '#0076b2',
    secondary: '#155800',
    accent: '#1A237E',
    info: '#000e20',
  },
  blanket: {
    // This one is godawful, don't bother
    primary: '#552525',
    secondary: '#c58139',
    accent: '#6db0a4',
    info: '#000e20',
  },
  leaf: {
    primary: '#638b08',
    secondary: '#524937',
    accent: '#0097A7',
    info: '#000e20',
  },
  mojito: {
    primary: '#efe5d4',
    secondary: '#5b8300',
    accent: '#f07d10',
    info: '#000e20',
  },
  peppermint: {
    //   It'd be a pain in the ass, but you might consider making the text/card backgrounds #dedbe6
    primary: '#283043',
    secondary: '#ae866a',
    accent: '#c42034',
    info: '#000e20',
  },
  candy: {
    primary: '#64c4d0',
    // secondary: '#3e1b0c',
    secondary: '#455a64',
    accent: '#d60000',
    info: '#000e20',
    error: '#d60000',
  },
  bluejito: {
    primary: '#efe5d4',
    secondary: '#2F4858',
    // accent: '#FF8B5C',
    accent: '#DB6B3D',
    // This is the accent we were going with for a while,
    // but apparently it's too low-contrast
    accent2: '#C34410',
    info: '#000e20',
    error: '#d60000',
  },
};
